import { deviceWidth } from './deviceWidth';
import { getContrastingColor } from './getContrastingColor';

export function getCustomHeaderTextColor(bgColor) {
  if (deviceWidth > 767) {
    return getContrastingColor(bgColor);
  }
  return 'black-90';
}
